<template>
    <div>
      <!-- section 1 -->
      <div class="landingBackground">
        <div class="section-one">
          <div class="wrapper">
            <h1>6 mesecev brezplačne </h1>
            <h2>uporabe T-2 TV</h2>
            <hr/>
            <p class="shorDescription" v-html="introText">
            </p>
            <v-btn v-if="!isAuthenticated" color="primary" depressed class="orangeButtonL" @click="login">
                ZAČNITE Z UPORABO
            </v-btn>
            <v-btn v-else color="primary" depressed class="orangeButtonL" @click="toCard">
                {{ buttonText }}
            </v-btn>
            <span class="free">6 MESECEV BREZPLAČNO</span>
          </div>
        </div>
      </div>
      <div class="sep">&nbsp;</div>
      <!-- section 2 -->
      <div class="section-two">
        <div class="wrapper text-center">
          <h2>
            Najboljši športni in filmski programi po prijazni ceni.
            <span>Tudi, če niste naročnik T-2.</span>
          </h2>
          <hr/>
          <p class="shorDescription">
            Pretočna T-2 TV v vaš dom pripelje bogat izbor filmskih programov,
            izjemne nogometne in košarkarske športne lige ter ostale zanimive
            športne dogodke. Vse vsebine lahko spremljate tudi na poti z mobilno
            aplikacijo – kjerkoli v EU. Potrebujete le internetno povezavo.
          </p>
        </div>
        <div class="relative">
          <div class="computerContainer">
            <img class="computerImage" src="../../../images/best/comp.png" alt=""/>
          </div>
          <div id="infinite" class="landing-slider">
            <ul class="landing-wrapper">
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-1.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-2.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-3.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-4.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-1.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-2.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-3.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-4.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-1.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-2.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-3.png"></v-img>
              </li>
              <li class="landing-image">
                <v-img src="@/images/best/Rectangle-4.png"></v-img>
              </li>
            </ul>
          </div>
        </div>
        <div class="wrapper">
          <v-btn v-if="!isAuthenticated" color="primary" depressed class="orangeButtonL" @click="login">
            ZAČNITE Z UPORABO
          </v-btn>
          <v-btn v-else color="primary" depressed class="orangeButtonL" @click="toCard">
            {{ buttonText }}
          </v-btn>
          <span class="free">6 MESECEV BREZPLAČNO</span>
        </div>
      </div>
      <div class="sep">&nbsp;</div>
      <!-- section 3-->
  
      <!-- section 4-->
      <div class="section-four">
        <div class="wrapper">
          <h2>Vrhunska TV izkušnja.<span>V vseh paketih.</span></h2>
          <div class="chooseYourPackage flex">
            <v-card class="boxBlack">
              <div class="content">
                <h3>Vedno nove vsebine v T-2 videoteki.</h3>
                <span class="desc">Z brezplačnim ogledom top filma meseca.</span>
                <v-img alt="Vedno nove vsebine v T-2 videoteki." src="@/images/image.png"></v-img>
              </div>
            </v-card>
            <v-card class="boxBlack">
              <div class="content">
                <h3>Tvoje vsebine pod tvojim profilom.</h3>
                <span class="desc">T-2 televizija ti glede na tvoj okus priporoča vsebine, ki te
                  zanimajo.</span>
                <v-img alt="Tvoje vsebine pod tvojim profilom." src="@/images/image1.png"></v-img>
              </div>
            </v-card>
            <v-card class="boxBlack">
              <div class="content">
                <h3>Do 7 dni časovnega zamika.</h3>
                <span class="desc">Edinstveno prikazovanje slik med prevrtavanjem z možnostjo
                  ogleda do 7 dni nazaj.</span>
                <div class="relativeVideo">
                  <v-img alt="Do 7 dni časovnega zamika." src="@/images/image2.png"></v-img>
                  <video class="video" playsinline autoplay muted loop
                         poster="@/images/tv-tv2-casovni-zamik_compressed.mp4">
                    <source :src="
                      require('@/images/tv-tv2-casovni-zamik_compressed.mp4')
                    " type="video/mp4"/>
                  </video>
                </div>
              </div>
            </v-card>
            <v-card class="boxBlack">
              <div class="content">
                <h3>Maratonsko gledanje priljubljene serije</h3>
                <span class="desc">Po končani epizodi se naslednji del predvaja samodejno.</span>
                <v-img alt="Do 7 dni časovnega zamika." src="@/images/image3.png"></v-img>
              </div>
            </v-card>
          </div>
          <v-btn v-if="!isAuthenticated" color="primary" depressed class="orangeButtonL" @click="login">
            ZAČNITE Z UPORABO
          </v-btn>
          <v-btn v-else color="primary" depressed class="orangeButtonL" @click="toCard">
            {{ buttonText }}
          </v-btn>
          <span class="free">6 MESECEV BREZPLAČNO</span>
        </div>
      </div>
      <div class="sep">&nbsp;</div>
      <!-- section 5-->
      <div class="section-five">
        <div class="wrapper">
          <h2>Vrhunska TV izkušnja.<span>Na vseh napravah.</span></h2>
          <hr/>
          <p class="shorDescription">
            T-2 televizija je mnogo več kot le izvrstna ponudba TV programov.
            Ponuja vam popolnoma novo gledalsko izkušnjo in vas vabi v svet, ki
            upošteva vaše gledalske navade in se jim prilagaja. Na vašem pametnem
            televizorju, računalniku ali mobilni napravi.
          </p>
  
          <div class="relativeVideo">
            <video class="video" playsinline autoplay muted loop
                   poster="@/images/tv-t2_glej-na-vseh-napravah_screen_3_compressed-2.mp4">
              <source :src="
                require('@/images/tv-t2_glej-na-vseh-napravah_screen_3_compressed-2.mp4')
              " type="video/mp4"/>
            </video>
            <v-img src="@/images/serije.png"></v-img>
          </div>
          <v-btn v-if="!isAuthenticated" color="primary" depressed class="orangeButtonL" @click="login">
            ZAČNITE Z UPORABO
          </v-btn>
          <v-btn v-else color="primary" depressed class="orangeButtonL" @click="toCard">
            {{ buttonText }}
          </v-btn>
          <span class="free">6 MESECEV BREZPLAČNO</span>
        </div>
      </div>
    </div>
  </template>
  <script>
  // Import Swiper Vue.js components
  import {directive} from "vue-awesome-swiper";
  import "swiper/swiper-bundle.css";
  import packagesAllPrograms from "@/config/packages";
  import {purchaseTypes} from "../../../enumerations/purchaseTypes";
  
  export default {
    components: {},
    directives: {
      swiper: directive,
    },
    data() {
      return {
        introText: "T-2 televizija je mnogo več kot le izvrstna ponudba TV programov. Ponuja vam popolnoma novo gledalsko izkušnjo in vas vabi v svet, ki upošteva vaše gledalske navade in se jim prilagaja. Na vašem pametnem televizorju, računalniku ali mobilni napravi – kjerkoli v EU. </br>Preizkusite jo!",
        dialog: false,
        words: ["CineStar Premiere", "Arena Sport", "Eurosport", "Šport TV"],
        changingText: "",
        packagesAllPrograms,
        packages: [],
        swiperOptions: {
          slidesPerView: 4,
          spaceBetween: 50,
          // Responsive breakpoints
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters["auth/isAuthenticated"];
      },
      buttonText() {
        return this.$store.getters['user/subscriptions'].length > 0 ? 'VSTOPI V PORTAL' : 'DOKONČAJTE NAKUP';
      }
    },
    mounted() {
      this.$store.dispatch('user/setPurchaseType', purchaseTypes.Promo);
      this.animatedText();
    },
    methods: {
      async login() {
        const hisenseCallback = this.$router.options.routes.find(item => item.name === 'HisenseCallback');
        const redirectUrl = window.location.origin + (hisenseCallback ? hisenseCallback.path : '/callback');
        this.$auth.login(redirectUrl);
      },
      toCard() {
        this.$router.push({name: "App_home"});
      },
      animatedText() {
        let currentText = parseInt(Math.random() * this.words.length);
        let areaText = this.words[0];
        this.t1 = setInterval(
          function () {
            let c = parseInt(
              Math.random() *
              Math.max(this.words[currentText].length, areaText.length)
            );
            let s = this.words[currentText][c];
            if (typeof s == "undefined") s = " ";
            while (areaText.length < c) areaText += " ";
            areaText = (areaText.slice(0, c) + s + areaText.slice(c + 1)).trim();
            this.changingText = areaText.length === 0 ? "" : areaText;
          }.bind(this),
          10
        );
        this.t2 = setInterval(
          function () {
            currentText = parseInt(Math.random() * this.words.length);
          }.bind(this),
          1000
        );
      },
    },
  };
  </script>
  